// PatientCard.jsx
// Individual card in the patient queue.

import { formatDistanceToNow } from "date-fns";

export default function PatientCard({ session, onAdmit, onForceEnd, disabled = false }) {
  const waitSince = session.patientJoinedAt
    ? formatDistanceToNow(new Date(session.patientJoinedAt), { addSuffix: true })
    : "just now";

  const apptTime = session.appointmentTime
    ? new Date(session.appointmentTime).toLocaleString("en-US", {
        month: "short", day: "numeric",
        hour: "2-digit", minute: "2-digit",
      })
    : null;

  const isWaiting    = session.status === "WAITING";
  const isInProgress = session.status === "IN_PROGRESS";

  return (
    <article
      className={`patient-card ${isInProgress ? "patient-card--active" : ""}`}
      aria-label={`Patient: ${session.patientName}, status: ${session.status}`}
    >
      {/* Avatar */}
      <div className="pc-avatar" aria-hidden="true">
        {session.patientName?.[0]?.toUpperCase() ?? "P"}
      </div>

      {/* Info */}
      <div className="pc-info">
        <h3 className="pc-name">{session.patientName}</h3>

        {apptTime && (
          <p className="pc-appt">
            <span aria-hidden="true">🗓</span> {apptTime}
          </p>
        )}

        <p className="pc-wait">
          {isWaiting    && <><span aria-hidden="true">⏱</span> Waiting {waitSince}</>}
          {isInProgress && <><span aria-hidden="true">🟢</span> In progress</>}
        </p>
      </div>

      {/* Status badge */}
      <div className={`pc-badge pc-badge--${isWaiting ? "waiting" : "active"}`}>
        {isWaiting ? "In Lobby" : "In Progress"}
      </div>

      {/* Action */}
      <div className="pc-actions">
        <button
          className="btn btn-primary btn-sm"
          onClick={() => onAdmit(session)}
          disabled={disabled || isInProgress}
          aria-label={`Start visit with ${session.patientName}`}
        >
          {isInProgress ? "In progress" : "Start Visit →"}
        </button>

        <button
          className="btn btn-ghost btn-sm pc-force-end"
          onClick={() => {
            if (window.confirm(`End session for ${session.patientName}? This will remove them from the queue.`)) {
              onForceEnd(session);
            }
          }}
          aria-label={`Force end session for ${session.patientName}`}
          title="Force-end this stuck session"
        >
          🗑 End
        </button>
      </div>
    </article>
  );
}
